import { browserHistory } from 'react-router';
import { change } from 'redux-form';
import { call, put, select, takeEvery, takeLatest, take } from 'redux-saga/effects';

import * as api from '../../services/job/api_job';
import * as apiCommon from '../../services/apiCommon';
import * as common from '../sagasCommon';
import * as DocType from '../../constants/constant_doc_types';


export function * fetchListJobSaga(feathersApp) {
  yield takeLatest('FETCH_LIST_JOB', callListJob, feathersApp);
}
function * callListJob(feathersApp, action) {
  const { filters, silent } = action;
  yield* common.showProgressListTable(silent);
  try {
    const dataParams = { 
      filters: {
        ...filters,
      },
      list_type: 'job'
    };
    const tableData = yield call(apiCommon.getDocs, feathersApp, dataParams);
    yield call(common.doneListTable, { rows: tableData.data, total_rows: tableData.total });
  } catch (error) {
    yield common.showErrorListTable(error);
  }
}




export function * deleteJobFromListSaga(feathersApp) {
  yield takeEvery('DELETE_JOB_FROM_LIST', callDeleteJobFromList, feathersApp);
}
function* callDeleteJobFromList(feathersApp, action) {
  yield deleteJob(feathersApp, action);
  yield callListJob(feathersApp, { silent: true });
}




function * deleteJob(feathersApp, action) {
  yield put({ type: 'DELETE_STATUS_INPROGRESS' });
  try {
      const { id } = action;
      let result = null;
      if(id) {
          const state = yield select();
          const { tenant, user } = state;
          const { id } = action;
          const params = { tenant, user, id };
          result = yield call(api.deleteJob, feathersApp, params);
      }
      yield put({ type: "DELETE_STATUS_DONE", payload: { id, docType: DocType.CSV_STATUS }});
      return result;
  } catch (error) {
      yield put({ type: 'DELETE_STATUS_ERROR', error })
  }
}




export function * deleteJobSaga(feathersApp) {
  yield takeEvery('DELETE_JOB', callDeleteJob, feathersApp);
}
function* callDeleteJob(feathersApp, action) {
  const result = yield call(deleteJob, feathersApp, action);
  if(result) {
    browserHistory.push('/admin/job_status');
  }
}




export function * viewJobDetailsSaga(feathersApp) {
  yield takeLatest('VIEW_JOB_DETAILS', callViewJobDetails, feathersApp);
}
function* callViewJobDetails(feathersApp, action) {
  browserHistory.push('/admin/job_status');
  yield take('FETCH_LIST_JOB');
  yield put(change('JobSearchForm', 'reference_id', action.id));
  yield put({ type: 'FETCH_LIST_JOB', filters: action.filters, silent: false });
}
